export const APP_CONTAINER_ID = 'apc-usc';
export const API_CHAT_CONFIG_URL = '/rest/model/schneider/site/rest/SiteActor/chatPopup';
export const API_COPY_LINK_CONFIG_URL =
    '/rest/model/schneider/chatlink/rest/CopyLinkActor/copyLink';
export const CSC_ID = 'Chat_CSC_ID';

export const COPY_LINK_BTN = 'copyBtn';
export const DEFAULT_SITE_ID = 'storeSiteUS';

export const SDL_HEADER_DESKTOP_INCREASED = 136;
export const SDL_HEADER_DESKTOP_REDUCED = 96;
export const OLD_MOBILE_BREAKPOINT_MAX = 960;

export const CHAT_ENABLED_PAGES = [
    /\/shop\/\w{2}\/\w{2}\/search/gi,
    /\/shop\/\w{2}\/\w{2}\/products/gi,
    /\/shop\/\w{2}\/\w{2}(\/tools)?\/surge-selector/gi,
    /\/shop\/\w{2}\/\w{2}(\/tools)?\/rack-pdu-selector/gi,
    /\/shop\/\w{2}\/\w{2}(\/tools)?\/ups_selector/gi,
    /\/shop\/\w{2}\/\w{2}(\/tools)?\/replacement-battery-selector/gi,
    /\/shop\/\w{2}\/\w{2}(\/tools)?\/service-selector/gi,
    /\/shop\/\w{2}\/\w{2}(\/tools)?\/software-firmware/gi,
    /\/shop\/tradeups\/\w{2}\/\w{2}/gi,
    /\/shop\/\w{2}\/\w{2}\/categories/gi, // Category pages aka Range Pages
    /\/shop\/\w{2}\/\w{2}\/checkout/gi,
    /\/shop\/\w{2}\/\w{2}\/payment/gi,
    /\/shop\/\w{2}\/\w{2}\/order/gi,
];

export const COPY_LINK_DISABLED_PAGES = [
    /\/shop\/\w{2}\/\w{2}\/payment\/CheckoutOrderReview\.jsp/gi,
    /\/shop\/\w{2}\/\w{2}\/order\/orderConfirmation\.jsp/gi,
];
